import { render, staticRenderFns } from "./DrugsInteractions.vue?vue&type=template&id=08b14952"
import script from "./DrugsInteractions.vue?vue&type=script&lang=js"
export * from "./DrugsInteractions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports